import React from 'react';
import classnames from 'classnames';
import { useDeviationViewContext } from '../../Context';
import ActionBarStrip from '../_partials/ActionBarStrip';
import SecondaryActionBarIcons from '../_partials/SecondaryActionBarIcons';
import s from './ActionBarDesktop.scss';
export var SecondaryActionBarDesktop = function (_a) {
    var deviation = _a.deviation, isOwner = _a.isOwner;
    var isTheater = useDeviationViewContext().isTheater;
    return (React.createElement(ActionBarStrip, { className: classnames(s['root'], isTheater && s['theater'], s['secondary']) },
        React.createElement("div", { className: s['icons-wrapper'] },
            React.createElement(SecondaryActionBarIcons, { deviation: deviation, isOwner: isOwner }))));
};
SecondaryActionBarDesktop.displayName = 'SecondaryActionBarDesktop';
export default SecondaryActionBarDesktop;
//# sourceMappingURL=SecondaryActionBarDesktop.js.map